import {RouterModule, Routes} from '@angular/router';
import {ServicesComponent} from "./pages/services/services.component";
import {ConsultationComponent} from "./pages/consultation/consultation.component";
import {AboutComponent} from "./pages/about/about.component";
import {PageNotFoundComponent} from "./pages/page-not-found/page-not-found.component";
import {NgModule} from "@angular/core";
import {HomePageComponent} from "./pages/home/home-page.component";
import { ContactUsComponent } from './pages/contact-us/contact-us.component';

export const routes: Routes = [
  { path: '', title: 'Home page', component: HomePageComponent },
  { path: 'services', component: ServicesComponent },
  { path: 'consultation', component: ConsultationComponent },
  { path: 'about', component: AboutComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: '**', component: PageNotFoundComponent },  // Wildcard route for a 404 page
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    bindToComponentInputs: true,
    initialNavigation: 'enabledNonBlocking',
    //useHash: true
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
